export function makeAccessible<T extends HTMLElement>(cb: (e: React.MouseEvent<T>) => void) {
  return {
    role: 'button',
    tabIndex: 0,
    onClick: cb,
    onKeyDown: (e: React.KeyboardEvent<T>) => {
      if (e.key === ' ' || e.key === 'Enter') cb(e as unknown as React.MouseEvent<T>);
    },
  };
}
